import React, { createContext, useContext, useState, useEffect, useRef, useCallback } from 'react';
import authService from '../services/authService';
import {
  getEffectivePermissions,
  userHasAnyPermission,
  userHasPermission,
  userHasRole,
} from '../utils/rbac';
const AuthContext = createContext(null);

// export const AuthProvider = ({ children }) => {
//   // Restaurer l'utilisateur depuis localStorage immédiatement pour éviter le flash
//   const getInitialUser = () => {
//     try {
//       const userStr = localStorage.getItem('user');
//       const token = localStorage.getItem('accessToken');
//       if (userStr && token) {
//         return JSON.parse(userStr);
//       }
//     } catch (error) {
//       console.error('Erreur lors de la lecture du localStorage:', error);
//     }
//     return null;
//   };

//   const [user, setUser] = useState(getInitialUser());
//   const [isLoading, setIsLoading] = useState(true);
//   const [isAuthenticated, setIsAuthenticated] = useState(!!getInitialUser());
//   const hasInitialized = useRef(false); // Protection contre les doubles appels

//   // Vérifier l'authentification au chargement
//   useEffect(() => {
//     // Éviter les doubles appels (React StrictMode en développement)
//     if (hasInitialized.current) return;
//     hasInitialized.current = true;

//     let isMounted = true; // Flag pour éviter les mises à jour après démontage

//     const initAuth = async () => {
//       try {
//         // Récupérer les tokens depuis localStorage
//         const token = localStorage.getItem('accessToken');
//         const refreshToken = localStorage.getItem('refreshToken');
//         const storedUserStr = localStorage.getItem('user');
        
//         console.log('🔍 [AUTH] Initialisation - Token:', token ? '✅ Présent' : '❌ Absent');
//         console.log('🔍 [AUTH] Initialisation - Refresh Token:', refreshToken ? '✅ Présent' : '❌ Absent');
//         console.log('🔍 [AUTH] Initialisation - User:', storedUserStr ? '✅ Présent' : '❌ Absent');

//         // Si on a un token ou un refresh token, essayer de restaurer la session
//         if (token || refreshToken) {
//           // D'abord, essayer avec le token actuel
//           if (token) {
//             try {
//               console.log('🔄 [AUTH] Tentative de restauration avec le token actuel...');
//               const response = await authService.getMe();
//               if (response?.data?.user) {
//                 const userData = response.data.user;
//                 console.log('✅ [AUTH] Session restaurée avec succès:', userData.email);
                
//                 if (isMounted) {
//                   setUser(userData);
//                   setIsAuthenticated(true);
//                   // Mettre à jour le localStorage avec les données complètes
//                   localStorage.setItem('user', JSON.stringify(userData));
//                 }
//                 return; // Succès, on sort
//               }
//             } catch (error) {
//               // Token invalide ou expiré, on va essayer de le rafraîchir
//               console.log('⚠️ [AUTH] Token invalide ou expiré:', error.message);
//               console.log('🔄 [AUTH] Tentative de rafraîchissement...');
//             }
//           }

//           // Si le token n'existe pas ou est invalide, essayer de le rafraîchir
//           if (refreshToken) {
//             try {
//               console.log('🔄 [AUTH] Rafraîchissement du token...');
//               await authService.refreshToken();
              
//               // Vérifier que le nouveau token est bien sauvegardé
//               const newToken = localStorage.getItem('accessToken');
//               if (!newToken) {
//                 throw new Error('Le nouveau token n\'a pas été sauvegardé');
//               }
              
//               console.log('✅ [AUTH] Token rafraîchi avec succès');
              
//               // Après le refresh, récupérer le profil
//               const response = await authService.getMe();
//               if (response?.data?.user) {
//                 const userData = response.data.user;
//                 console.log('✅ [AUTH] Session restaurée après rafraîchissement:', userData.email);
                
//                 if (isMounted) {
//                   setUser(userData);
//                   setIsAuthenticated(true);
//                   // Mettre à jour le localStorage avec les données complètes
//                   localStorage.setItem('user', JSON.stringify(userData));
//                 }
//                 return; // Succès, on sort
//               }
//             } catch (refreshError) {
//               console.error('❌ [AUTH] Erreur lors du rafraîchissement:', refreshError.message);
//               // Refresh échoué, nettoyer et déconnecter
//               if (isMounted) {
//                 console.log('🧹 [AUTH] Nettoyage des tokens...');
//                 localStorage.removeItem('accessToken');
//                 localStorage.removeItem('refreshToken');
//                 localStorage.removeItem('user');
//                 setUser(null);
//                 setIsAuthenticated(false);
//               }
//             }
//           } else {
//             // Pas de refresh token, nettoyer
//             console.log('❌ [AUTH] Pas de refresh token disponible');
//             if (isMounted) {
//               localStorage.removeItem('accessToken');
//               localStorage.removeItem('refreshToken');
//               localStorage.removeItem('user');
//               setUser(null);
//               setIsAuthenticated(false);
//             }
//           }
//         } else {
//           // Pas de tokens, utilisateur non connecté
//           console.log('ℹ️ [AUTH] Aucun token trouvé, utilisateur non connecté');
//           if (isMounted) {
//             setUser(null);
//             setIsAuthenticated(false);
//           }
//         }
//       } catch (error) {
//         console.error('❌ [AUTH] Erreur lors de l\'initialisation:', error);
//         if (isMounted) {
//           setUser(null);
//           setIsAuthenticated(false);
//         }
//       } finally {
//         if (isMounted) {
//           setIsLoading(false);
//         }
//       }
//     };

//     initAuth();

//     // Cleanup function
//     return () => {
//       isMounted = false;
//     };
//   }, []);

//   const login = async (email, password) => {
//     try {
//       const response = await authService.login(email, password);
      
//       // Vérifier que les tokens sont bien sauvegardés
//       const savedToken = localStorage.getItem('accessToken');
//       const savedRefreshToken = localStorage.getItem('refreshToken');
      
//       if (!savedToken || !savedRefreshToken) {
//         console.error('Les tokens n\'ont pas été sauvegardés correctement');
//         throw new Error('Erreur lors de la sauvegarde des tokens');
//       }
      
//       const userData = response.data.user;
//       setUser(userData);
//       setIsAuthenticated(true);
      
//       // S'assurer que l'utilisateur est bien sauvegardé
//       localStorage.setItem('user', JSON.stringify(userData));
      
//       return { success: true, data: response.data };
//     } catch (error) {
//       return {
//         success: false,
//         message: error.message || 'Erreur lors de la connexion',
//       };
//     }
//   };

//   const register = async (userData) => {
//     try {
//       const response = await authService.register(userData);
      
//       // Vérifier que les tokens sont bien sauvegardés
//       const savedToken = localStorage.getItem('accessToken');
//       const savedRefreshToken = localStorage.getItem('refreshToken');
      
//       if (!savedToken || !savedRefreshToken) {
//         console.error('Les tokens n\'ont pas été sauvegardés correctement');
//         throw new Error('Erreur lors de la sauvegarde des tokens');
//       }
      
//       const userDataFromResponse = response.data.user;
//       setUser(userDataFromResponse);
//       setIsAuthenticated(true);
      
//       // S'assurer que l'utilisateur est bien sauvegardé
//       localStorage.setItem('user', JSON.stringify(userDataFromResponse));
      
//       return { success: true, data: response.data };
//     } catch (error) {
//       return {
//         success: false,
//         message: error.message || 'Erreur lors de l\'inscription',
//         errors: error.response?.errors || null, // Inclure les erreurs spécifiques du backend
//       };
//     }
//   };

//   const logout = async () => {
//     try {
//       await authService.logout();
//     } catch (error) {
//       // Erreur silencieuse lors de la déconnexion
//     } finally {
//       setUser(null);
//       setIsAuthenticated(false);
//     }
//   };

//   const refreshUser = async () => {
//     try {
//       const response = await authService.getMe();
//       if (response?.data?.user) {
//         const userData = response.data.user;
//         setUser(userData);
//         localStorage.setItem('user', JSON.stringify(userData));
//         return userData;
//       }
//     } catch (error) {
//       console.error('Erreur lors du rafraîchissement des données utilisateur:', error);
//       // En cas d'erreur (token expiré, etc.), on ne fait rien
//       // L'utilisateur devra se reconnecter
//     }
//   };

//   const value = {
//     user,
//     isAuthenticated,
//     isLoading,
//     login,
//     register,
//     logout,
//     refreshUser,
//   };

//   return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
// };

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (!context) {
//     throw new Error('useAuth doit être utilisé dans un AuthProvider');
//   }
//   return context;
// };



export const AuthProvider = ({ children }) => {
  // Restaurer l'utilisateur depuis localStorage immédiatement pour éviter le flash
  const getInitialUser = () => {
    try {
      const userStr = localStorage.getItem('user');
      const token = localStorage.getItem('accessToken');
      if (userStr && token) {
        return JSON.parse(userStr);
      }
    } catch (error) {
      console.error('Erreur lors de la lecture du localStorage:', error);
    }
    return null;
  };

  const [user, setUser] = useState(getInitialUser());
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(!!getInitialUser());
  const hasInitialized = useRef(false); // Protection contre les doubles appels

  // Vérifier l'authentification au chargement
  useEffect(() => {
    // Éviter les doubles appels (React StrictMode en développement)
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    let isMounted = true; // Flag pour éviter les mises à jour après démontage

    const initAuth = async () => {
      try {
        // Récupérer les tokens depuis localStorage
        const token = localStorage.getItem('accessToken');
        const refreshToken = localStorage.getItem('refreshToken');
        const storedUserStr = localStorage.getItem('user');
        
        console.log('🔍 [AUTH] Initialisation - Token:', token ? '✅ Présent' : '❌ Absent');
        console.log('🔍 [AUTH] Initialisation - Refresh Token:', refreshToken ? '✅ Présent' : '❌ Absent');
        console.log('🔍 [AUTH] Initialisation - User:', storedUserStr ? '✅ Présent' : '❌ Absent');

        // Si on a un token ou un refresh token, essayer de restaurer la session
        if (token || refreshToken) {
          // D'abord, essayer avec le token actuel
          if (token) {
            try {
              console.log('🔄 [AUTH] Tentative de restauration avec le token actuel...');
              const response = await authService.getMe();
              if (response?.data?.user) {
                const userData = response.data.user;
                console.log('✅ [AUTH] Session restaurée avec succès:', userData.email);
                
                if (isMounted) {
                  setUser(userData);
                  setIsAuthenticated(true);
                  // Mettre à jour le localStorage avec les données complètes
                  localStorage.setItem('user', JSON.stringify(userData));
                }
                return; // Succès, on sort
              }
            } catch (error) {
              // Token invalide ou expiré, on va essayer de le rafraîchir
              console.log('⚠️ [AUTH] Token invalide ou expiré:', error.message);
              console.log('🔄 [AUTH] Tentative de rafraîchissement...');
            }
          }

          // Si le token n'existe pas ou est invalide, essayer de le rafraîchir
          if (refreshToken) {
            try {
              console.log('🔄 [AUTH] Rafraîchissement du token...');
              await authService.refreshToken();
              
              // Vérifier que le nouveau token est bien sauvegardé
              const newToken = localStorage.getItem('accessToken');
              if (!newToken) {
                throw new Error('Le nouveau token n\'a pas été sauvegardé');
              }
              
              console.log('✅ [AUTH] Token rafraîchi avec succès');
              
              // Après le refresh, récupérer le profil
              const response = await authService.getMe();
              if (response?.data?.user) {
                const userData = response.data.user;
                console.log('✅ [AUTH] Session restaurée après rafraîchissement:', userData.email);
                
                if (isMounted) {
                  setUser(userData);
                  setIsAuthenticated(true);
                  // Mettre à jour le localStorage avec les données complètes
                  localStorage.setItem('user', JSON.stringify(userData));
                }
                return; // Succès, on sort
              }
            } catch (refreshError) {
              console.error('❌ [AUTH] Erreur lors du rafraîchissement:', refreshError.message);
              // Refresh échoué, nettoyer et déconnecter
              if (isMounted) {
                console.log('🧹 [AUTH] Nettoyage des tokens...');
                localStorage.removeItem('accessToken');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('user');
                setUser(null);
                setIsAuthenticated(false);
              }
            }
          } else {
            // Pas de refresh token, nettoyer
            console.log('❌ [AUTH] Pas de refresh token disponible');
            if (isMounted) {
              localStorage.removeItem('accessToken');
              localStorage.removeItem('refreshToken');
              localStorage.removeItem('user');
              setUser(null);
              setIsAuthenticated(false);
            }
          }
        } else {
          // Pas de tokens, utilisateur non connecté
          console.log('ℹ️ [AUTH] Aucun token trouvé, utilisateur non connecté');
          if (isMounted) {
            setUser(null);
            setIsAuthenticated(false);
          }
        }
      } catch (error) {
        console.error('❌ [AUTH] Erreur lors de l\'initialisation:', error);
        if (isMounted) {
          setUser(null);
          setIsAuthenticated(false);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    initAuth();

    // Cleanup function
    return () => {
      isMounted = false;
    };
  }, []);

  const login = async (email, password) => {
    try {
      const response = await authService.login(email, password);
      
      // Vérifier que les tokens sont bien sauvegardés
      const savedToken = localStorage.getItem('accessToken');
      const savedRefreshToken = localStorage.getItem('refreshToken');
      
      if (!savedToken || !savedRefreshToken) {
        console.error('Les tokens n\'ont pas été sauvegardés correctement');
        throw new Error('Erreur lors de la sauvegarde des tokens');
      }
      
      const userData = response.data.user;
      setUser(userData);
      setIsAuthenticated(true);
      
      // S'assurer que l'utilisateur est bien sauvegardé
      localStorage.setItem('user', JSON.stringify(userData));
      
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Erreur lors de la connexion',
      };
    }
  };

  const register = async (userData) => {
    try {
      const response = await authService.register(userData);
      
      // Vérifier que les tokens sont bien sauvegardés
      const savedToken = localStorage.getItem('accessToken');
      const savedRefreshToken = localStorage.getItem('refreshToken');
      
      if (!savedToken || !savedRefreshToken) {
        console.error('Les tokens n\'ont pas été sauvegardés correctement');
        throw new Error('Erreur lors de la sauvegarde des tokens');
      }
      
      const userDataFromResponse = response.data.user;
      setUser(userDataFromResponse);
      setIsAuthenticated(true);
      
      // S'assurer que l'utilisateur est bien sauvegardé
      localStorage.setItem('user', JSON.stringify(userDataFromResponse));
      
      return { success: true, data: response.data };
    } catch (error) {
      return {
        success: false,
        message: error.message || 'Erreur lors de l\'inscription',
        errors: error.response?.errors || null, // Inclure les erreurs spécifiques du backend
      };
    }
  };

  const logout = async () => {
    try {
      await authService.logout();
    } catch (error) {
      // Erreur silencieuse lors de la déconnexion
    } finally {
      setUser(null);
      setIsAuthenticated(false);
    }
  };

  const refreshUser = async () => {
    try {
      const response = await authService.getMe();
      if (response?.data?.user) {
        const userData = response.data.user;
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
        return userData;
      }
    } catch (error) {
      console.error('Erreur lors du rafraîchissement des données utilisateur:', error);
      // En cas d'erreur (token expiré, etc.), on ne fait rien
      // L'utilisateur devra se reconnecter
    }
  };

  /**
   * Fonction pour définir l'authentification directement (utilisée pour OAuth, etc.)
   * Met à jour localStorage ET l'état React immédiatement
   * @param {string} token - Token d'accès
   * @param {object} userData - Données utilisateur
   * @param {string} refreshToken - Token de rafraîchissement (optionnel)
   */
  const setAuthData = (token, userData, refreshToken = null) => {
    console.log('🔐 [AUTH] setAuthData appelé - Mise à jour de l\'état d\'authentification');
    
    // Sauvegarder dans localStorage
    localStorage.setItem('accessToken', token);
    if (refreshToken) {
      localStorage.setItem('refreshToken', refreshToken);
    }
    if (userData) {
      localStorage.setItem('user', JSON.stringify(userData));
    }

    // Mettre à jour l'état React immédiatement
    setUser(userData);
    setIsAuthenticated(true);
    
    console.log('✅ [AUTH] État d\'authentification mis à jour:', {
      token: token ? `${token.substring(0, 20)}...` : 'null',
      user: userData?.email || 'null',
      isAuthenticated: true
    });
  };

  const hasRole = useCallback(
    (...roles) => userHasRole(user, ...roles),
    [user]
  );

  const hasPermission = useCallback(
    (perm) => userHasPermission(user, perm),
    [user]
  );

  const hasAnyPermission = useCallback(
    (...perms) => userHasAnyPermission(user, perms),
    [user]
  );

  const effectivePermissions = getEffectivePermissions(user);

  const value = {
    user,
    isAuthenticated,
    isLoading,
    login,
    register,
    logout,
    refreshUser,
    setAuthData,
    hasRole,
    hasPermission,
    hasAnyPermission,
    effectivePermissions,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth doit être utilisé dans un AuthProvider');
  }
  return context;
};

/*
 */
